import { useAuth0 } from '@auth0/auth0-react';
import { isAdmin } from '../utils/roleUtils';

export const useAuth = () => {
  const {
    isAuthenticated,
    loginWithRedirect,
    logout,
    user,
    getAccessTokenSilently,
    isLoading,
  } = useAuth0();

  const login = () => loginWithRedirect();

  const logoutUser = () => {
    logout({ returnTo: window.location.origin });
  };

  const getToken = async () => {
    try {
      return await getAccessTokenSilently();
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  };

  return {
    isAuthenticated,
    user,
    login,
    logout: logoutUser,
    getToken,
    isLoading,
    isAdmin: user ? isAdmin(user) : false,
  };
};
